module.exports = __webpack_public_path__ + "img/gi.abba45d2.svg";